import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from "framer-motion";
import PublicLayout from './components/Common/PublicLayout';
import HomePage from './pages/Home';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import Docs from './pages/Docs';
import About from './pages/About';
import Contact from './pages/Contact';
import Integrations from './pages/Integrations';
import ApiDocs from './pages/ApiDocs';
import Changelog from './pages/Changelog';
import Blog from './pages/Blog';
import Careers from './pages/Careers';
import PressKit from './pages/PressKit';
import HelpCenter from './pages/HelpCenter';
import Community from './pages/Community';
import Webinars from './pages/Webinars';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CookiePolicy from './pages/CookiePolicy';
import AuthForm from './components/LoginRegister';
import VerifyEmail from './components/VerifyEmail';
import './App.css';

const APP_URL = process.env.REACT_APP_CHATBOT_URL || "http://localhost:3000";

function RedirectIfLoggedIn() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get("logged_out") === "1") {
      localStorage.clear();
      window.history.replaceState(null, "", "/");
      return;
    }

    if (["/login", "/signup", "/verify-email"].includes(location.pathname)) return;

    const stored = localStorage.getItem("user");
    if (stored && stored !== "undefined") {
      try {
        const u = JSON.parse(stored);
        if (u.token) {
          const params = new URLSearchParams({
            token: u.token, userId: u._id || '', role: u.role || '',
            name: u.fullName || '', email: u.email || '', plan: u.plan || '',
          });
          window.location.href = `${APP_URL}/auth/callback?${params.toString()}`;
          return;
        }
      } catch (_) {}
      window.location.href = `${APP_URL}/app/dashboard`;
    }
  }, [location]);

  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

const Page = ({ children }) => <PublicLayout>{children}</PublicLayout>;

function App() {
  const location = useLocation();
  return (
    <>
      <RedirectIfLoggedIn />
      <ScrollToTop />
      <AnimatePresence mode="wait">
        <motion.div key={location.pathname} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} transition={{ duration: 0.2 }}>
          <Routes location={location}>
            <Route index element={<HomePage />} />
            <Route path="features" element={<Page><Features /></Page>} />
            <Route path="pricing" element={<Page><Pricing /></Page>} />
            <Route path="docs" element={<Page><Docs /></Page>} />
            <Route path="about" element={<Page><About /></Page>} />
            <Route path="contact" element={<Page><Contact /></Page>} />
            <Route path="integrations" element={<Page><Integrations /></Page>} />
            <Route path="api-docs" element={<Page><ApiDocs /></Page>} />
            <Route path="changelog" element={<Page><Changelog /></Page>} />
            <Route path="blog" element={<Page><Blog /></Page>} />
            <Route path="careers" element={<Page><Careers /></Page>} />
            <Route path="press-kit" element={<Page><PressKit /></Page>} />
            <Route path="help-center" element={<Page><HelpCenter /></Page>} />
            <Route path="community" element={<Page><Community /></Page>} />
            <Route path="webinars" element={<Page><Webinars /></Page>} />
            <Route path="privacy-policy" element={<Page><PrivacyPolicy /></Page>} />
            <Route path="terms-of-service" element={<Page><TermsOfService /></Page>} />
            <Route path="cookie-policy" element={<Page><CookiePolicy /></Page>} />
            <Route path="login" element={<AuthForm />} />
            <Route path="signup" element={<AuthForm />} />
            <Route path="verify-email" element={<VerifyEmail />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </motion.div>
      </AnimatePresence>
    </>
  );
}

export default App;
